import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

// width/height 는 webp 실제 픽셀 치수 — CSS(h-[50px]/h-[36px] + w-auto)가 표시 크기를
// 정하고, 속성은 브라우저가 로드 전에 종횡비를 계산해 레이아웃 밀림(CLS)을 막는 용도다.
// large: 도안이 커 보이는 로고는 균형을 위해 표시 높이를 36px 로 줄인다.
type PartnerLogo = { src: string; width: number; height: number; large?: boolean };

const LOGOS: readonly PartnerLogo[] = [
  { src: '/images/optimized/home/partners/01.webp', width: 133, height: 51 },
  { src: '/images/optimized/home/partners/02.webp', width: 517, height: 100 },
  { src: '/images/optimized/home/partners/03.webp', width: 421, height: 100 },
  { src: '/images/optimized/home/partners/04.webp', width: 408, height: 100 },
  { src: '/images/optimized/home/partners/05.webp', width: 331, height: 100, large: true },
  { src: '/images/optimized/home/partners/06.webp', width: 481, height: 100, large: true },
  { src: '/images/optimized/home/partners/07.webp', width: 497, height: 100, large: true },
  { src: '/images/optimized/home/partners/08.webp', width: 334, height: 100 },
  { src: '/images/optimized/home/partners/09.webp', width: 175, height: 43 },
  { src: '/images/optimized/home/partners/10.webp', width: 154, height: 46 },
  { src: '/images/optimized/home/partners/11.webp', width: 102, height: 100 },
  { src: '/images/optimized/home/partners/12.webp', width: 54, height: 71 },
  { src: '/images/optimized/home/partners/13.webp', width: 71, height: 85 },
];

export function PartnersSlider() {
  useTranslation('home');

  const getLogoClass = (logo: PartnerLogo) =>
    logo.large ? 'h-[36px] w-auto shrink-0 object-contain' : 'h-[50px] w-auto shrink-0 object-contain';

  return (
    <section className="flex w-full flex-col items-center gap-8 pt-10 md:gap-[48px] md:pt-[58px]">
      <div className="flex w-full flex-col items-stretch gap-5 md:items-center md:gap-[26px]">
        <h2 className="w-full px-5 text-left text-[15px] font-semibold leading-[1.4] tracking-[-0.022em] text-[#222222] md:w-auto md:px-0 md:text-center md:text-[24px] md:leading-[1.5]">
          <Trans
            i18nKey="home:partners.title"
            components={{
              span: <span className="text-primary" />,
              br: <br />,
            }}
          />
        </h2>

        <div className="relative w-full overflow-hidden">
          <div className="animate-infinite-scroll flex items-center gap-[52px]">
            {/* 첫 번째 세트 */}
            {LOGOS.map((logo, index) => (
              <img
                key={`first-${index}`}
                src={logo.src}
                width={logo.width}
                height={logo.height}
                alt="Partner organization logos"
                loading="lazy"
                className={getLogoClass(logo)}
              />
            ))}
            {/* 두 번째 세트 */}
            {LOGOS.map((logo, index) => (
              <img
                key={`second-${index}`}
                src={logo.src}
                width={logo.width}
                height={logo.height}
                alt="Partner organization logos"
                loading="lazy"
                className={getLogoClass(logo)}
              />
            ))}
            {/* 세 번째 세트 (더 부드러운 전환을 위해) */}
            {LOGOS.map((logo, index) => (
              <img
                key={`third-${index}`}
                src={logo.src}
                width={logo.width}
                height={logo.height}
                alt="Partner organization logos"
                loading="lazy"
                className={getLogoClass(logo)}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="h-px w-full bg-[#DFDFDF]" />
    </section>
  );
}
